import { IPassengerForStationDto } from "../../models";
import { unique } from "../array.helpers";

export const getSourceStationsIdsFromPassengers = ({
  passengers,
}: {
  passengers: IPassengerForStationDto[];
}): number[] => {
  return unique(
    passengers.reduce<number[]>((acc, passenger) => {
      if (passenger.sourceStation1Id) {
        acc.push(passenger.sourceStation1Id);
      }
      if (passenger.sourceStation2Id) {
        acc.push(passenger.sourceStation2Id);
      }
      if (passenger.sourceStation3Id) {
        acc.push(passenger.sourceStation3Id);
      }
      return acc;
    }, []),
  );
};

export const getDestinationStationsIdsFromPassengers = ({
  passengers,
}: {
  passengers: IPassengerForStationDto[];
}): number[] => {
  return unique(
    passengers.reduce<number[]>((acc, passenger) => {
      if (passenger.destinationStation1Id) {
        acc.push(passenger.destinationStation1Id);
      }
      if (passenger.destinationStation2Id) {
        acc.push(passenger.destinationStation2Id);
      }
      if (passenger.destinationStation3Id) {
        acc.push(passenger.destinationStation3Id);
      }
      return acc;
    }, []),
  );
};
